import { useEffect } from 'react';
import { Card, Row, Col, Statistic, Button, Typography, Space } from 'antd';
import { FileTextOutlined, PlusOutlined, CheckCircleOutlined, EditOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/auth';
import { useMappingsStore } from '../store/mappings';

const { Title, Paragraph } = Typography;

export function Dashboard() {
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const { mappings, fetchMappings } = useMappingsStore();

  useEffect(() => {
    fetchMappings();
  }, [fetchMappings]);

  const totalMappings = mappings.length;
  const verifiedMappings = mappings.filter((m) => m.status === 'VERIFIED').length;
  const draftMappings = mappings.filter((m) => m.status === 'DRAFT').length;
  const activeMappings = mappings.filter((m) => m.status === 'ACTIVE').length;

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <Title level={2}>Welcome back, {user?.attributes?.name || user?.username}!</Title>
        <Paragraph type="secondary">
          Manage your document mapping templates and extract data with ease.
        </Paragraph>
      </div>

      <Row gutter={[16, 16]} style={{ marginBottom: 32 }}>
        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic
              title="Total Mappings"
              value={totalMappings}
              prefix={<FileTextOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic
              title="Active"
              value={activeMappings}
              prefix={<CheckCircleOutlined />}
              valueStyle={{ color: '#52c41a' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic
              title="Verified"
              value={verifiedMappings}
              prefix={<CheckCircleOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic
              title="Drafts"
              value={draftMappings}
              prefix={<EditOutlined />}
              valueStyle={{ color: '#8c8c8c' }}
            />
          </Card>
        </Col>
      </Row>

      <Card title="Quick Actions" style={{ marginBottom: 24 }}>
        <Space size="large">
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => navigate('/mappings/create')}
            size="large"
          >
            Create New Mapping
          </Button>
          <Button
            icon={<FileTextOutlined />}
            onClick={() => navigate('/mappings')}
            size="large"
          >
            View All Mappings
          </Button>
        </Space>
      </Card>

      <Card title="Recent Activity">
        <Paragraph type="secondary">
          {mappings.length > 0
            ? `You have ${totalMappings} mapping templates. ${draftMappings > 0 ? `${draftMappings} templates are in draft status and need to be verified.` : 'All templates are verified or active.'}`
            : 'No mappings yet. Create your first mapping template to get started.'}
        </Paragraph>
      </Card>
    </div>
  );
}
